import { ReactComponent as SvgAda } from './ADA.svg.es.js';
import { ReactComponent as SvgAlgo } from './ALGO.svg.es.js';
import { ReactComponent as SvgApt } from './APT.svg.es.js';
import { ReactComponent as SvgAptos } from './APTOS.svg.es.js';
import { ReactComponent as SvgArb } from './ARB.svg.es.js';
import { ReactComponent as SvgAvax } from './AVAX.svg.es.js';
import { ReactComponent as SvgBase } from './BASE.svg.es.js';
import { ReactComponent as SvgBnb } from './BNB.svg.es.js';
import { ReactComponent as SvgBtc } from './BTC.svg.es.js';
import { ReactComponent as SvgCelo } from './CELO.svg.es.js';
import { ReactComponent as SvgCodex } from './CODEX.svg.es.js';
import { ReactComponent as SvgDot } from './DOT.svg.es.js';
import { ReactComponent as SvgEos } from './EOS.svg.es.js';
import { ReactComponent as SvgEth } from './ETH.svg.es.js';
import { ReactComponent as SvgEvmos } from './EVMOS.svg.es.js';
import { ReactComponent as SvgFlow } from './FLOW.svg.es.js';
import { ReactComponent as SvgHbar } from './HBAR.svg.es.js';
import { ReactComponent as SvgLinea } from './LINEA.svg.es.js';
import { ReactComponent as SvgMana } from './MANA.svg.es.js';
import { ReactComponent as SvgMatic } from './MATIC.svg.es.js';
import { ReactComponent as SvgNear } from './NEAR.svg.es.js';
import { ReactComponent as SvgNeo } from './NEO.svg.es.js';
import { ReactComponent as SvgNoble } from './NOBLE.svg.es.js';
import { ReactComponent as SvgOp } from './OP.svg.es.js';
import { ReactComponent as SvgPah } from './PAH.svg.es.js';
import { ReactComponent as SvgPoly } from './POLY.svg.es.js';
import { ReactComponent as SvgS } from './S.svg.es.js';
import { ReactComponent as SvgSettlus } from './SETTLUS.svg.es.js';
import { ReactComponent as SvgSol } from './SOL.svg.es.js';
import { ReactComponent as SvgSui } from './SUI.svg.es.js';
import { ReactComponent as SvgTrx } from './TRX.svg.es.js';
import { ReactComponent as SvgUni } from './UNI.svg.es.js';
import { ReactComponent as SvgUnknown } from './Unknown.svg.es.js';
import { ReactComponent as SvgWld } from './WLD.svg.es.js';
import { ReactComponent as SvgXlm } from './XLM.svg.es.js';
import { ReactComponent as SvgXrp } from './XRP.svg.es.js';
import { ReactComponent as SvgZks } from './ZKS.svg.es.js';

const SvgTokenIcons = {
    ADA: SvgAda,
    ALGO: SvgAlgo,
    APT: SvgApt,
    APTOS: SvgAptos,
    ARB: SvgArb,
    AVAX: SvgAvax,
    BASE: SvgBase,
    BNB: SvgBnb,
    BTC: SvgBtc,
    CELO: SvgCelo,
    CODEX: SvgCodex,
    DOT: SvgDot,
    EOS: SvgEos,
    ETH: SvgEth,
    EVMOS: SvgEvmos,
    FLOW: SvgFlow,
    HBAR: SvgHbar,
    LINEA: SvgLinea,
    MANA: SvgMana,
    MATIC: SvgMatic,
    NEAR: SvgNear,
    NEO: SvgNeo,
    NOBLE: SvgNoble,
    OP: SvgOp,
    PAH: SvgPah,
    POLY: SvgPoly,
    S: SvgS,
    SETTLUS: SvgSettlus,
    SOL: SvgSol,
    SUI: SvgSui,
    TRX: SvgTrx,
    UNI: SvgUni,
    WLD: SvgWld,
    XLM: SvgXlm,
    XRP: SvgXrp,
    ZKS: SvgZks,
    Unknown: SvgUnknown
};

export { SvgTokenIcons };
//# sourceMappingURL=index.es.js.map
